import React from "react";
import { useTranslation } from "react-i18next";
import Label from "~/components-shared/Label";
import Text from "~/components-shared/Text";
import Grid from "~/components-shared/Grid";
import InputTextControl from "~/components/InputTextControl";
import InputTextAreaControl from "~/components/InputTextAreaControl";
import InputDateControl from "~/components/InputDateControl";
import { useSelector } from "react-redux";
import integrationSelectors from "~/store/integrations/selectors";
import { AIGenerateTargetEnum, ImageCategoryEnum, IntegrationTypeEnum } from "~/types/enums";
import ImageUploadControl from "~/components/ImageUploadControl/ImageUploadControl";
import InputColorControl from "~/components/InputColorControl";
import styled, { useTheme } from "styled-components";
import AiGenerateButton from "~/components/AiGenerateButton";
const StyledAiButton = styled(AiGenerateButton)`
  position: absolute;
  bottom: 1.2rem;
  right: 1rem;
`;
const StyledGridCell = styled(Grid.Cell)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const CommunityForm = _ref => {
  let {
    community,
    control,
    watch,
    setValue,
    setError
  } = _ref;
  const {
    colors
  } = useTheme();
  const slackIntegration = useSelector(integrationSelectors.getIntegrationByType(IntegrationTypeEnum.SLACK));
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    template: "1fr 150px",
    gap: 6
  }, /*#__PURE__*/React.createElement(StyledGridCell, {
    align: "stretch"
  }, /*#__PURE__*/React.createElement(InputTextControl, {
    name: "name",
    label: t("CommunityForm.name"),
    s: {
      mb: 3
    },
    control: control,
    emojiPicker: true,
    required: true
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, {
    s: {
      px: 0.5,
      mb: 2
    },
    required: true
  }, t("CommunityForm.mission")), /*#__PURE__*/React.createElement(Text, {
    element: "p",
    color: "textSecondary",
    s: {
      mb: 4,
      px: 0.5
    }
  }, t("CommunityForm.missionDescription")))), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(ImageUploadControl, {
    initPreview: community?.picture,
    name: "picture",
    control: control,
    label: t("CommunityForm.uploadLogo"),
    s: {
      mt: 3,
      mb: 6
    },
    category: ImageCategoryEnum.COMMUNITY,
    width: "150px",
    height: "150px",
    ai: {
      value: watch("name"),
      tip: t("CommunityForm.generateImage"),
      noValueError: t("CommunityForm.generateImageError")
    }
  }))), /*#__PURE__*/React.createElement(InputTextAreaControl, {
    name: "mission",
    rows: 6,
    s: {
      mb: 2,
      px: 0.5
    },
    control: control,
    required: true,
    emojiPicker: true
  }, /*#__PURE__*/React.createElement(StyledAiButton, {
    target: AIGenerateTargetEnum.COMMUNITY_SUMMARY,
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("CommunityForm.generateMission"),
    value: watch("name"),
    onGenerateStarted: () => setError("mission", {}),
    onGenerateSucceeded: text => setValue("mission", text),
    onGenerateFailed: message => setError("mission", {
      type: "custom",
      message
    })
  })), /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 4,
    equal: true
  }, /*#__PURE__*/React.createElement(InputTextControl, {
    name: "email",
    label: t("CommunityForm.email"),
    control: control
  }), /*#__PURE__*/React.createElement(InputDateControl, {
    name: "founded",
    label: t("CommunityForm.founded"),
    control: control,
    direction: "topLeft",
    required: true
  }), /*#__PURE__*/React.createElement(InputColorControl, {
    name: "color",
    label: t("CommunityForm.color"),
    control: control,
    direction: "topLeft",
    required: true
  }), slackIntegration && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InputTextControl, {
    name: "slackName",
    label: t("CommunityForm.slackName"),
    elemBefore: /*#__PURE__*/React.createElement(Text, {
      s: {
        mr: 2
      },
      weight: "semiBold",
      color: colors.text.secondary
    }, "#"),
    control: control,
    required: true
  }))));
};
export default CommunityForm;